import Vue from 'vue'
import { post } from './axios'
import { getQueryVariable, checkMobile, checkEmail, checkEmpty } from './Tool';


import {
    QiniuUpload,
    Base64ImgUpload,
} from '../lib/QiniuUpload.js'

// 七牛上传
Vue.prototype.$QiniuUpload = QiniuUpload
    // post请求
Vue.prototype.$post = post
    // 获取当前页面url里面的参数
Vue.prototype.$getQueryVariable = getQueryVariable




// 手机号验证
Vue.prototype.$checkMobile = checkMobile
    // 手机号验证
Vue.prototype.$checkEmail = checkEmail
    // 空验证
Vue.prototype.$checkEmpty = checkEmpty